import { api } from './api'

export const getFeatureFlag = (flagName: string): Promise<{ state: boolean }> =>
  api.get(`/feature-flags/${flagName}`)
